import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  createIntraOccupationalReport(_, { action, payload }) {
    let method = 'post'
    let url = `${serverUrl}/reports/intra_occupational_report/generate_report/` 
    // if (action === 'update') {
    //   method = 'put'
    //   url = `${payload.url}generate_report/`
    // }
    return axios[method](url, payload)
  },
}